import React from 'react';
import { formatValueIfNullOrUndefined, formatDate } from 'utilities/util';
import { PropertiesRibbonWrapper } from 'components/properties-ribbon';

interface ITopBarOwnProps {
    number: string;
    incoTerm: string;
    shipmentType: string;
    originService: string;
    destinationService: string;
    etd: string;
    placeOfReceiptCode: string;
    portOfLoadingCode: string;
    portOfDischargeCode: string;
    placeOfDeliveryCode: string;
    soNumber: string;
    isActionHidden: boolean
}

export const DetailsTopBar: React.FunctionComponent<ITopBarOwnProps> = (props) => {
    const propertiesRibbonData = {
        labels: [
            { label: 'Internal Document number', value: formatValueIfNullOrUndefined(props.number), key: `fcr-number` },
            { label: 'Incoterm', value: formatValueIfNullOrUndefined(props.incoTerm), key: `fcr-incoTerm` },
            { label: 'Shipment type', value: formatValueIfNullOrUndefined(props.shipmentType), key: `fcr-shipmentType` },
            { label: 'Origin/Destination Service', value: `${formatValueIfNullOrUndefined(props.originService)}/${formatValueIfNullOrUndefined(props.destinationService)}`, key: `fcr-originService` },
            { label: 'ETD', value: formatDate(props.etd, 'YYYY-MM-DD'), key: `fcr-etd` },
            { label: 'Place of Receipt', value: formatValueIfNullOrUndefined(props.placeOfReceiptCode), key: `fcr-placeOfReceiptCode` },
            { label: 'Port of Loading', value: formatValueIfNullOrUndefined(props.portOfLoadingCode), key: `fcr-portOfLoadingCode` },
            { label: 'Port Of Discharge', value: formatValueIfNullOrUndefined(props.portOfDischargeCode), key: `fcr-portOfDischargeCode` },
            { label: 'Place Of Delivery', value: formatValueIfNullOrUndefined(props.placeOfDeliveryCode), key: `fcr-placeOfDeliveryCode` },
            { label: 'Primary Sales Order Number', value: formatValueIfNullOrUndefined(props.soNumber), key: `fcr-createdDate` }
        ],
        actions: [],
        isActionHidden: props.isActionHidden
    }
    return (
        <React.Fragment>
            <PropertiesRibbonWrapper content={propertiesRibbonData} key={`-bookingDetailsTopBar-${Math.random()}`} />
        </React.Fragment>
    )
};